import React, { Component } from 'react';
import __ from 'lodash';
import { Bar } from 'react-chartjs-2';

class GraphSosEkonomi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",                    
            labels: [],
            datasets: [],
            tipe: 'PROVINSI',
        }
    }

    componentDidMount() {              
        if(!__.isEmpty(this.props.data)) { 
            let labels = [], datas = [];
            this.props.data.map(d => {
                labels.push(d.namaKategori);
                datas.push(d.prosen);
            })
            this.setState({
                title: this.props.title,
                labels: labels,
                datasets: datas,
                tipe: this.props.tipe
            })            
        }
    }

    render() {  
        const options = {
            legend: { position: 'top' },
            scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      stacked: true,
                      steps: 10,
                      max: 100
                    },
                  },
                ],
                xAxes: [{
                    barThickness: 45,
                    ticks: {
                        autoSkip: false,
                        maxRotation: 60,
                        minRotation: 60
                    }
                }]
            },
            responsive: false,
            maintainAspectRatio: true,        
        }
        return(
            <Bar 
                data={{
                    labels: this.state.labels,
                    datasets: [
                        {      
                            label: this.state.title,                          
                            data: this.state.datasets,
                            backgroundColor: this.state.tipe === 'PROV' ? 'rgba(75,192,192,1)' : 'rgb(54, 162, 235)'                         
                        }
                    ]
                }} 
                options={options} 
                width={450} height={300}
            />
        )
    }
}

export default GraphSosEkonomi;